import { render } from "./CalendarDayPrevious.vue?vue&type=template&id=ca5865c6&ts=true"
import script from "./CalendarDayPrevious.vue?vue&type=script&lang=ts"
export * from "./CalendarDayPrevious.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__